import { Children, cloneElement, type ReactElement } from 'react'

import { type ClonableChildProps, type DndDragArgs, type DndDropArgs, draggableProps, droppableProps } from './props'

/**
 * Stamps drag and/or drop props onto a single child element: no extra DOM node.
 * A plain function rather than a component, so the kit's Draggable and Droppable
 * each cost one fiber instead of two; dense grids render hundreds of them.
 * Nesting a Draggable directly inside a Droppable would lose the outer props,
 * because each only reads its own props off the child.
 */
export function stampDndProps(args: { drag?: DndDragArgs; drop?: DndDropArgs; disabled?: boolean; child: ReactElement }): ReactElement {
    const { drag, drop, disabled = false } = args
    const child = Children.only(args.child)
    if (disabled) return child
    const childProps = child.props as ClonableChildProps
    return cloneElement(child, {
        ...(drop === undefined ? {} : droppableProps(drop, childProps)),
        ...(drag === undefined ? {} : draggableProps(drag, childProps)),
    })
}
